module.exports = __webpack_public_path__ + "img/limparFiltros.863cbc94.svg";